let utils = require('../../../actions/utils');
let content = require('../../../actions/layout/content');
let userGroup = require('../../groups/user/index');
let layoutGroup = require('../../groups/layout/index');
let userForm = require('../../../actions/account/user-form');
let passwordChange = require('../../../actions/account/password-change');
let analytics = require('../../../actions/analytics');
let seo = require('../../../actions/seo');
let registration = require('../../../actions/auth/registration');
let error = require('../../../actions/error');

module.exports = [
    analytics.parseUtmFromQuery,
    ...userGroup.checkAuthCookie([
        ...userGroup.getUser
    ]),
    ...userGroup.access('account', [
        utils.set('layout', 'main'),
        ...layoutGroup.setMainLayoutBlocks,
        [
            registration.getCountries, {
                success: [
                    utils.setFromArgsToState('countries', ['account', 'userForm', 'countries'])
                ],
                error: [ error.internalError('personal.getCountries') ]
            }
        ],
        utils.setPopupVisibility('registrationCountryDropdown', ['account', 'userForm', 'popups', 'countryDropdown',
            'isOpen']),
        seo.setDashboardMeta('Информация обо мне - Библиотека данных', 'Редактирование личной информации'),
        content.setComponentsByLink,
        [
            userForm.getCurrentUserData,
            {
                success: [
                    userForm.setComputedFields,
                    userForm.initUserForm,
                    passwordChange.setComputedFields,
                    passwordChange.resetUserForm
                ]
            }
        ],
        analytics.pageview
    ])
];



// WEBPACK FOOTER //
// ./signals/pages/personal/index.js